import {get,post,put} from './http'
export const updateInfo = (params) => put('/min-program/v1/parent/info',params);